import React, { useEffect, useState } from 'react';

import { SavedLabelStyles as S } from './styles';

const relative = ms => {
  if (ms == null) return null;
  const secs = Math.max(0, Math.floor(ms / 1000));
  if (secs < 5) return 'just now';
  if (secs < 60) return `${secs}s ago`;
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  return `${hrs}h ago`;
};

const SavedLabel = ({ savedAt }) => {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (!savedAt) return undefined;
    const id = setInterval(() => setNow(Date.now()), 15000);
    return () => clearInterval(id);
  }, [savedAt]);

  useEffect(() => {
    setNow(Date.now());
  }, [savedAt]);

  if (!savedAt) return null;

  return (
    <S.Wrap title='Auto-saved to this browser. Submit to send it to Beam.'>
      <S.Dot />
      Saved · {relative(now - savedAt)}
    </S.Wrap>
  );
};

export default SavedLabel;
